import { createStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
//#region src/CommentCommandState.ts
var r = e((e) => ({
	activeCommentId: void 0,
	setActiveCommentId: (t) => e({ activeCommentId: t }),
	activeReplyId: void 0,
	setActiveReplyId: (t) => e({ activeReplyId: t }),
	commentState: void 0,
	setCommentState: (t) => e({ commentState: t }),
	commentReplyState: void 0,
	setCommentReplyState: (t) => e({ commentReplyState: t }),
	clearCommentState: () => e({
		commentState: void 0,
		commentReplyState: void 0
	}),
	annotationState: void 0,
	setAnnotationState: (t) => e({ annotationState: t }),
	annotationViewpointCaptureState: void 0,
	setAnnotationViewpointCaptureState: (t) => e({ annotationViewpointCaptureState: t }),
	clearAnnotationState: () => e({
		annotationState: void 0,
		annotationViewpointCaptureState: void 0
	}),
	clear: () => e({
		activeCommentId: void 0,
		activeReplyId: void 0,
		commentState: void 0,
		commentReplyState: void 0,
		annotationState: void 0,
		annotationViewpointCaptureState: void 0
	})
})), i = (e) => t(r, n(e));
//#endregion
export { r as commentCommandStateStore, i as useCommentCommandStateStore };
